export const DEPARTMENTS = ["Enquiries", "Sales", "Operations", "Finance", "Technical Support", "Accounts", "Parts", "HR", "Warranty", "Maintenance", "Shop", "Archive"];
export const ACTIVE_DEPARTMENTS = DEPARTMENTS.filter((d) => d !== "Archive");

export const DEPT_COLOUR = {
  Enquiries: "green",
  Sales: "blue",
  Operations: "indigo",
  Finance: "purple",
  "Technical Support": "sky",
  Accounts: "teal",
  Parts: "amber",
  HR: "pink",
  Warranty: "orange",
  Maintenance: "rose",
  Shop: "emerald",
  Archive: "slate",
};

export const DEPT_TEXT = {
  green: "text-green-700", blue: "text-blue-700", indigo: "text-indigo-700", purple: "text-purple-700",
  sky: "text-sky-700", teal: "text-teal-700", amber: "text-amber-700", pink: "text-pink-700",
  orange: "text-orange-700", rose: "text-rose-700", emerald: "text-emerald-700", slate: "text-slate-700",
};

export const DEPT_TEAM_LABEL = {
  Enquiries: "Sales Team",
  Sales: "Sales Team",
  Operations: "Operations Team",
  Finance: "Finance Team",
  Archive: "Finance Team",
  "Technical Support": "Technical Support Team",
  Accounts: "Accounts Team",
  Parts: "Parts Team",
  HR: "HR Team",
  Warranty: "Warranty Team",
  Maintenance: "Maintenance Team",
  Shop: "Shop Team",
};
